const AUTH_USER = "AUTH_USER";

export default {
  AUTH_USER,
};
